import React from 'react';
import PropTypes from 'prop-types';
import { FamilyTreeProvider } from './FamilyTreeProvider';
import FamilyTreeCanvas from './FamilyTreeCanvas';
import ZoomControls from './ZoomControls';

const FamilyTree = ({ characters, showSpouses, onNodeClick, style, centerOnCharacterId }) => {
  return (
    <div style={{ width: '100%', height: '100%', position: 'relative', ...style }}>
      <FamilyTreeProvider
        characters={characters}
        showSpouses={showSpouses}
        centerOnCharacterId={centerOnCharacterId}
      >
        <FamilyTreeCanvas onNodeClick={onNodeClick} />
        <ZoomControls />
      </FamilyTreeProvider>
    </div>
  );
};

FamilyTree.propTypes = {
  characters: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string,
      connections: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  showSpouses: PropTypes.bool,
  onNodeClick: PropTypes.func,
  style: PropTypes.shape({}),
  centerOnCharacterId: PropTypes.string,
};

FamilyTree.defaultProps = {
  characters: [],
  showSpouses: true,
  onNodeClick: null,
  style: {},
  centerOnCharacterId: null,
};

export default FamilyTree;
